var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
            if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
    return t;
};
import { fetcher } from '@ef-carbon/fetcher';
import {
    Guid,
    stringConvert,
    Url
} from '@ef-carbon/primitive';
import render from '../../render';
import isIData from '../remote/isIData';
import { get as regexGet } from '../remote/regex';
const maximum = 1024 * 8;
export async function linkProcessRemote(link, context, {
    regex,
    headers: hdrsExtra
}) {
    const {
        redirect: redirection,
        url,
        headers: hdrsBase = {},
        body,
        method = 'POST'
    } = link;
    const redirect = redirection ? new Guid(redirection) : undefined;
    const parsed = stringConvert(url);
    const rendered = render(parsed, context);
    const endpoint = new Url(rendered);
    if (endpoint.protocol !== 'https:') {
        throw new TypeError(`Can only perform requests to HTTPS endpoints, '${ endpoint }' is invalid`);
    } else if (regex && !regex.test(`${ endpoint }`) || !regexGet().test(`${ endpoint }`)) {
        throw new TypeError(`The endpoint '${ endpoint }' is blacklisted`);
    }
    const init = { method };
    const headers = new Headers([
        ...Object.entries(hdrsBase),
        ...new Headers(hdrsExtra)
    ]);
    if (typeof body === 'string') {
        const keys = __rest(context, []);
        init.body = render(body, Object.assign({ context: JSON.stringify(context) }, keys));
    } else {
        init.body = JSON.stringify({ context });
        headers.set('Content-Type', 'application/json');
    }
    for (const [key, value] of headers) {
        headers.set(key, render(value, context));
    }
    init.headers = headers;
    const request = new Request(`${ endpoint }`, init);
    const response = await fetcher(request);
    const length = response.headers.get('Content-Length');
    if (length !== null) {
        const content = parseInt(length, 10);
        if (content > maximum) {
            throw new RangeError(`Remote response length (${ content }) is not in range [0, ${ maximum }]`);
        }
    }
    const {
        id,
        context: ctx
    } = await response.json(isIData);
    return {
        id: new Guid(id),
        redirect,
        context: ctx
    };
}
export {
    linkProcessRemote as process,
    linkProcessRemote as remote
};
export default linkProcessRemote;    //# sourceMappingURL=remote.js.map
